import axios from "axios";
import { BASE_URI_NODEJS, BASE_URI_PHP } from "../core.js";

const getHeaders = () => {
  return {
    headers: {
      Authorization: `token 894de9366f20b7d0ddd25dcbe044efd6e17f52f8`,
    },
  };
};

const post = async (url, body, condition = "php") => {
  try {
    const response = await axios.post(
      condition === "php" ? BASE_URI_PHP + url : url,
      body,
      getHeaders()
    );
    return response?.data;
  } catch (error) {
    return error.response.data;
  }
};

const get = async (url, condition = "php") => {
  try {
    const response = await axios.get(
      (condition === "php" ? BASE_URI_PHP : BASE_URI_NODEJS) + url,
      getHeaders()
    );
    return response?.data;
  } catch (error) {
    return error.response.data;
  }
};

const getElectionNews = async (setElectionNews) => {
  const response = await get("/electionNews", "nodejs");
  if (response.status === "success") {
    setElectionNews(response.data);
  }
};

const isNotNullOrEmpty = (variable) => {
  return variable !== "" && variable !== undefined && variable !== null;
};

const convertTime = (time) => {
  return new Date(time).toLocaleTimeString();
};

// Membership# Functions

const checkDocNoLength = (type) => {
  if (type === "NIC") {
    return 11;
  } else if (type === "JCIC") {
    return 16;
  } else if (type === "JID") {
    return 11;
  }
};

const checkMembershipNoMask = (type) => {
  if (type === "NIC") {
    return "99999-9999999-9";
  } else if (type === "JCIC") {
    return "9999 9999 9999 9999";
  } else if (type === "JID") {
    return "99999-999-99-a";
  }
};

const getHelperText = (type) => {
  if (type === "NIC") {
    return "Minimum length for Old CNIC: 11, New CNIC: 13";
  } else {
    return "Minimum length should be " + checkDocNoLength(type);
  }
};

const extractNumber = (e) => {
  let value = e.target.value;
  value = value.replaceAll("_", "");
  value = value.replaceAll("-", "");
  return value.replaceAll(" ", "");
};

const checkMembershipNoLength = (type, num) => {
  if (type === "NIC") {
    let flag = true;
    if (num.length === 13 || num.length === 11) {
      flag = false;
    }
    return flag;
  } else {
    return num.length !== checkDocNoLength(type);
  }
};

const getGenderFromCode = (code) => {
  if (code === "M") {
    return "Male";
  } else if (code === "F") {
    return "Female";
  } else {
    return "";
  }
};

export {
  get,
  post,
  getGenderFromCode,
  getElectionNews,
  checkMembershipNoMask,
  checkMembershipNoLength,
  isNotNullOrEmpty,
  getHelperText,
  extractNumber,
  convertTime,
};
